export default __webpack_public_path__ + "static/media/thirdstepsm.540b4807.png";